import authorizedAxios from "../../helpers/authorizedAxios";

export const SET_STOCK_HISTORY = "SET_STOCK_HISTORY";
export const SET_STOCK_HISTORY_LOADING = "SET_STOCK_HISTORY_LOADING";
export const SET_STOCK_HISTORY_ERROR = "SET_STOCK_HISTORY_ERROR";

export const fetchStockHistories = (params = {}) => {
  return async (dispatch) => {
    dispatch({ type: SET_STOCK_HISTORY_LOADING, status: true });

    try {
      const response = await authorizedAxios.get("/stock-reports/histories", { params });
      dispatch({
        type: SET_STOCK_HISTORY,
        data: response?.data?.data || null,
      });
      return response?.data?.data || null;
    } catch (error) {
      dispatch({
        type: SET_STOCK_HISTORY_ERROR,
        error: error?.response?.data?.message || "Gagal mengambil histori stock.",
      });
      return null;
    } finally {
      dispatch({ type: SET_STOCK_HISTORY_LOADING, status: false });
    }
  };
};
